import { FC } from "react";
import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/Save";
import LoadingButton from "@mui/lab/LoadingButton";

interface LoadFileProps {
  fileName: string;
  isFileSaving: boolean;
  handleFileUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  savePersonFromXLS: () => void;
  disabled: boolean;
}

const LoadFile: FC<LoadFileProps> = (props) => {
  const { fileName, isFileSaving, handleFileUpload, savePersonFromXLS, disabled } = props;
  return (
    <div>
      <Typography variant='h6' align='center'>
        Cargar archivo XLS
      </Typography>
      <TextField label={fileName} margin='normal' disabled fullWidth />
      <InputWrapper>
        <div>
          <InputStyled accept='.xls,.xlsx' id='contained-button-file' type='file' onChange={handleFileUpload} />
          <label htmlFor='contained-button-file'>
            <Button variant='outlined' color='primary' component='span' startIcon={<CloudUploadIcon />}>
              Seleccionar archivo
            </Button>
          </label>
          <LoadingButton
            loading={isFileSaving}
            color='primary'
            variant='contained'
            loadingPosition='start'
            startIcon={<SaveIcon />}
            onClick={savePersonFromXLS}
            disabled={disabled}
            sx={{ margin: "0 0 0 10px" }}
          >
            <span>Cargar</span>
          </LoadingButton>
        </div>
      </InputWrapper>
    </div>
  );
};

export default LoadFile;

const InputWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 24px;
`;

const InputStyled = styled("input")`
  display: none;
`;
